import template from './search-criteria-group-item.html';

const DIRECTIVE_NAME = SearchCriteriaGroupItem.DIRECTIVE_NAME = 'ktSearchCriteriaGroupItem';
export default function SearchCriteriaGroupItem() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: SearchCriteriaGroupItemController,
        controllerAs: '$ctrl',
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            index: `=${DIRECTIVE_NAME}Index`,
            frequentFlights: `=${DIRECTIVE_NAME}FrequentFlights`,
            timeOptions: `=${DIRECTIVE_NAME}TimeOptions`,
            cabinClasses: `=${DIRECTIVE_NAME}CabinClasses`,
            onRemove: `&${DIRECTIVE_NAME}OnRemove`,
            prevSegment: `=${DIRECTIVE_NAME}PrevSegment`,
        },
        link: function($scope, $elem, $attrs, searchCriteriaGroupItemCtrl) {
            searchCriteriaGroupItemCtrl.$onInit();
        },
    };
}

export function SearchCriteriaGroupItemController(
    $scope,
    userService,
    flightsApiService,
    MOMENT,
    searchCriteriaGroupItemService,
    timeService,
    flightsService,
    l10nService
) {
    'ngInject';

    const vm = this;
    const fromToPlaceholder = l10nService.localize('City or Airport...');
    let rsDateFormat;

    Object.assign(vm, {
        fromToPlaceholder,
        $onInit,
        getTypeaheadLocation,
        workingHoursRestriction: userService.getUser().WorkingHoursRestriction,
        getFrequentFlightView: searchCriteriaGroupItemService.getFrequentFlightView,
        setSelectedFrequentFlight: searchCriteriaGroupItemService.setSelectedFrequentFlight,
        isCurrentDay: flightsService.isCurrentDay,
    });

    function $onInit() {
        rsDateFormat = userService.getRegionalSettings().dateFormat;
        initDatePicker();
        watchPreviousDate();
        watchDateChange();
    }

    function watchPreviousDate() {
        if (vm.prevSegment) {
            $scope.$watch(() => vm.prevSegment._date, () => {
                const {_date: previousDate} = vm.prevSegment;
                const prevSegmentDate = timeService.parse(vm.prevSegment._date);
                const currentSegmentDate = timeService.parse(vm.model.TicketSearchSegments[vm.index]._date);
                if (previousDate) {
                    vm.pickerOptions.after = moment(prevSegmentDate).subtract(1, 'days');
                    vm.pickerOptions.start = moment(prevSegmentDate);
                }
                if (prevSegmentDate.isAfter(currentSegmentDate)) {
                    vm.model.TicketSearchSegments[vm.index]._date = null;
                }
            });
        }
    }

    function initDatePicker() {
        const {dateFormat} = userService.getRegionalSettings();
        const {_date = null} = vm.model.TicketSearchSegments[vm.index];
        vm.initDate = timeService.getDateInUserRegionFormatOrCurrentDate(_date);
        vm.pickerOptions = {
            dateFormat,
            placeholder: l10nService.localize('Depart date'),
            required: true,
            months: 2,
            start: vm.initDate,
            after: moment().add({days: -1}),
            before: flightsService.getMaxBookDate(),
        };
    }

    function watchDateChange() {
        $scope.$watch(() => vm.model.TicketSearchSegments[vm.index]._date, recalculateTimeOptions);

        function recalculateTimeOptions() {
            const {_date: date,
                   _time: time} = vm.model.TicketSearchSegments[vm.index];
            const departDate = moment(date, rsDateFormat);
            const now = MOMENT.init();
            let minHour;

            if (departDate.isValid() && isSame()) {
                vm.filteredTimeOptions = _.filter(angular.copy(vm.timeOptions), (item) => item.startHour >= minHour);

                const departTime = time;
                if (!_.find(vm.filteredTimeOptions, departTime)) {
                    Object.assign(time, vm.filteredTimeOptions[0]);
                }
            } else {
                vm.filteredTimeOptions = vm.timeOptions;
                Object.assign(time, vm.filteredTimeOptions[0]);
            }

            function isSame() {
                if (vm.index === 0) {
                    minHour = now.hour();
                    return departDate.isSame(now, 'day');
                }
                    const prevDate = moment(vm.model.TicketSearchSegments[vm.index - 1]._date, rsDateFormat);
                    minHour = vm.model.TicketSearchSegments[vm.index - 1]._time.startHour % 24;

                    if (minHour === 0 && departDate.isSame(now, 'day')) {
                        minHour = now.hour();
                    }

                    return prevDate.isValid() && departDate.isSame(prevDate, 'day');

            }
        }
    }

    function getTypeaheadLocation(searchPattern) {
        vm.airports = [];
        if (searchPattern && searchPattern.length < 2) {
            return vm.airports;
        }
        const params = {
            params: {searchPattern},
            noSpinner: true,
        };
        return flightsApiService.searchLocation(params);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/search-criteria-group-item/search-criteria-group-item-component.js